var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "12", md: "12", lg: "12" } },
            [
              _c(
                "b-alert",
                {
                  staticClass: "title mt-4 text-justify",
                  attrs: { show: "", variant: "info" },
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "text-justify",
                      staticStyle: { "font-weight": "normal" },
                    },
                    [
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "apeironGwApp.reconsideracion.instructions.arguments"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.reconsideracion.instructions.originalElements"
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.reconsideracion.instructions.plainText"
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.reconsideracion.instructions.saveAndSend"
                              )
                            ) +
                            ",\n            "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.reconsideracion.diasporaGuardar"
                              )
                            )
                          ),
                        ]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.reconsideracion.instructions.saveAndSend1"
                              )
                            ) +
                            "\n            "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.reconsideracion.diasporaAcciones"
                              )
                            )
                          ),
                        ]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.reconsideracion.instructions.saveAndSend2"
                              )
                            ) +
                            "\n            "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.reconsideracion.diasporaEnviar"
                              )
                            )
                          ),
                        ]),
                        _vm._v(".\n          "),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.reconsideracion.instructions.receipt"
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.reconsideracion.instructions.renunciation"
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tieneReconsideracionActiva
            ? _c(
                "b-col",
                { attrs: { sm: "12", md: "12", lg: "12" } },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "title mt-4 text-justify",
                      attrs: { show: "", variant: "danger" },
                    },
                    [
                      _c(
                        "ul",
                        {
                          staticClass: "text-center",
                          staticStyle: { "font-weight": "bold" },
                        },
                        [
                          _c("li", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "apeironGwApp.reconsideracion.alertActivaReconsideracion"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.onTimeReconsideracion
            ? _c(
                "b-col",
                { attrs: { sm: "12", md: "12", lg: "12" } },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "title mt-4 text-justify",
                      attrs: { show: "", variant: "danger" },
                    },
                    [
                      _c(
                        "ul",
                        {
                          staticClass: "text-center",
                          staticStyle: { "font-weight": "bold" },
                        },
                        [
                          _c("li", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "apeironGwApp.reconsideracion.alertPeriodoConcluido"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.tieneReconsideracionActiva
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "4", md: "4", lg: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.reconsideracion.fechaEnvio"
                        ),
                        "label-class": "font-weight-bold",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "select-insititucion-id",
                          value: _vm.formatoFecha(
                            _vm.reconsideracion.fechaEnvio
                          ),
                          readonly: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-overlay",
                {
                  attrs: {
                    show: _vm.onProcess,
                    "spinner-type": "grow",
                    "spinner-variant": "info",
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "12" } },
                        [
                          _c(
                            "b-alert",
                            {
                              staticClass: "title mt-4 text-justify",
                              attrs: { show: "", variant: "info" },
                            },
                            [
                              _c("strong", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.reconsideracion.diasporaPerfil"
                                      )
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.reconsideracion.diasporaAlertPerfil"
                                    )
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _vm.onTimeReconsideracion &&
                              _vm.canReconsiderar &&
                              !_vm.tieneReconsideracionActiva
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "success",
                                        type: "button",
                                        size: "sm",
                                      },
                                      domProps: {
                                        textContent: _vm._s("Consultar"),
                                      },
                                      on: { click: _vm.consultaPerfilRizoma },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "arrow-clockwise" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.reconsideracion.diasporaConsultarPu"
                                ),
                                "label-class": "font-weight-bold",
                              },
                            },
                            [
                              _c(
                                "b-input-group",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "select-entidad-id",
                                      value: _vm.reconsideracion.nuevaUriPu,
                                      readonly: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-input-group-append",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.reconsideracion.nuevaUriPu,
                                              expression:
                                                "reconsideracion.nuevaUriPu",
                                            },
                                          ],
                                          attrs: {
                                            variant: "light",
                                            disabled:
                                              !_vm.reconsideracion.nuevaUriPu,
                                          },
                                          on: { click: _vm.abrirNuevaUrlPu },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.reconsideracion.diasporaAbrir"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "12" } },
                        [
                          _c(
                            "b-alert",
                            {
                              staticClass: "title mt-4 text-justify",
                              attrs: { show: "", variant: "info" },
                            },
                            [
                              _c("strong", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.reconsideracion.diasporaEnlacePersonal"
                                      )
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.reconsideracion.diasporaAlertRepositorio"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.reconsideracion.diasporaRepositorio"
                                ),
                                "label-class": "font-weight-bold",
                                state: _vm.urlRepositorioState,
                                "invalid-feedback": "La URL no es válida",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "nueva-url-repositorio",
                                  type: "url",
                                  pattern:
                                    "https?://(www\\.)?[a-zA-Z0-9-]+(\\.[a-zA-Z]{2,})(/[^\\s]*)?",
                                  placeholder: "https://ejemplo.com",
                                  state: _vm.urlRepositorioState,
                                  disabled:
                                    !_vm.onTimeReconsideracion ||
                                    !_vm.canReconsiderar ||
                                    _vm.tieneReconsideracionActiva,
                                },
                                model: {
                                  value: _vm.reconsideracion.urlRepositorio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.reconsideracion,
                                      "urlRepositorio",
                                      $$v
                                    )
                                  },
                                  expression: "reconsideracion.urlRepositorio",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "12", md: "12", lg: "12" } },
            [
              _c("br"),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-class": "font-weight-bold",
                    state: _vm.urlArgumentosState,
                    "invalid-feedback":
                      "El argumento debe tener entre 300 y 10,000 caracteres.",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "apeironGwApp.reconsideracion.argumentos"
                                )
                              ) +
                              " "
                          ),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v("*"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("b-form-textarea", {
                    attrs: {
                      id: "reconsideracaion-text-id",
                      state: _vm.urlArgumentosState,
                      minlength: "300",
                      maxlength: "10000",
                      rows: "7",
                      disabled:
                        !_vm.onTimeReconsideracion ||
                        !_vm.canReconsiderar ||
                        _vm.tieneReconsideracionActiva,
                    },
                    model: {
                      value: _vm.reconsideracion.motivo,
                      callback: function ($$v) {
                        _vm.$set(_vm.reconsideracion, "motivo", $$v)
                      },
                      expression: "reconsideracion.motivo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("br"),
              _vm._v(" "),
              _vm.onTimeReconsideracion &&
              _vm.canReconsiderar &&
              !_vm.tieneReconsideracionActiva
                ? _c("b-button", {
                    attrs: {
                      variant: "primary",
                      type: "button",
                      size: "sm",
                      disabled:
                        !_vm.urlRepositorioState || !_vm.urlArgumentosState,
                    },
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.reconsideracion.diasporaGuardar")
                      ),
                    },
                    on: { click: _vm.guardarReconsideracion },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }